import ApplicationModel, { attr } from '../ApplicationModel';
import { type IdeaOrganizationAttributes } from './generated/IdeaOrganizationAttributes';
import { model } from '../modelBuilder';

interface IdeaOrganization extends IdeaOrganizationAttributes {}

@model
class IdeaOrganization extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaOrganization' = 'IdeaOrganization';
  get typename(): 'IdeaOrganization' {
    return 'IdeaOrganization';
  }

  static internalTypename: 'Ideas::IdeaOrganization' =
    'Ideas::IdeaOrganization';
  get internalTypename(): 'Ideas::IdeaOrganization' {
    return 'Ideas::IdeaOrganization';
  }

  static terminologyName = 'Organization';

  static filterType = 'IdeaOrganizationFilters!';
  static filters = { id: '[ID!]', query: 'String' };

  static fields = {
    accountId: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    revenue: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    account: attr.belongsTo({ readable: true, typename: 'Account' }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
  };
  // End auto-generated
}

export default IdeaOrganization;
